import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { showToast } from "src/utils/showToaster";
import ModuleForm from "../Layouts/ModuleForm";
import { ModuleFormValues } from "src/models/Module.model";
import { useAddModuleMutation } from "src/services/ModuleService";

type Props = {
  onClose: () => void;
};

const AddModuleWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const initialValues: ModuleFormValues = {
    moduleName: "",
    order: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    moduleName: string().required("Please enter Module name"),
    order: string().required("Please enter order"),
  });

  const [addModule] = useAddModuleMutation();

  // Handle Submit
  const handleSubmit = (
    values: ModuleFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ModuleFormValues>
  ) => {
    const payload = {
      moduleName: values.moduleName,
      order: Number(values.order),
    };
    addModule(payload).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <ModuleForm
              formikProps={formikProps}
              onClose={onClose}
              formType="ADD"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddModuleWrapper;
